import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'

export default {
  name: 'addEpiApr',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      cancelaRisco: false,
      formAddRisco: {
        risco: null
      },
      probabilidadeSeveridadeMatriz: [],
      severidadeDescricao: null,
      severidadeSelecionada: null,
      severidadeValor: null,
      severidadeEnum: {
        I: 'I_Desprezivel',
        II: 'II_Marginal',
        III: 'III_Critica',
        IV: 'IV_Catastrofica'
      },
      probabilidadeDescricao: null,
      probabilidadeSelecionada: null,
      probabilidadeValor: null,
      probabilidadeEnum: {
        A: 'A_Extremamente_Remoto',
        B: 'B_Remoto',
        C: 'C_Pouco_Provavel',
        D: 'D_Provavel',
        E: 'E_Frequente'
      },
      matrizRiscoSelecionada: null,
      classificacaoDescricao: null,
      colorFonteClassificacao: null,
      colorClassificacao: null,
      matrizRiscoEnum: {
        T: 'Toleravel',
        M: 'Moderado',
        NT: 'Nao_Tolerado'
      },
      avalicaoMatrizRisco: null,
      probabilidade: null,
      matrizRisco: null,
      severidade: null
    }
  },

  props: {
    avalicaoMemoria: {
      type: Boolean,
      default: false
    },
    edicaoAvaliacao: {
      type: Boolean,
      default: false
    },
    aprTemplateReprovado: {
      type: Boolean,
      default: false
    },
    aprTemplateAgAprovacao: {
      type: Boolean,
      default: false
    },
    avalicaoRiscoId: {
      type: String,
      default: ''
    },
    avalicaotemplateId: {
      type: String,
      default: ''
    },
    avalicaoAgAprovacaotemplateId: {
      type: String,
      default: ''
    },
    causaMedidaFonteId: {
      type: String,
      default: ''
    },
    etapaServicoId: {
      type: String,
      default: ''
    },
    avalicaoCausaId: {
      type: String,
      default: ''
    },
    avalicaoRevisao: {
      type: Number,
      default: 0
    },
    avalicaoP: {
      type: Number,
      default: 0
    },
    avalicaoS: {
      type: Number,
      default: 0
    },
    avalicaoCR: {
      type: Number,
      default: 0
    }
  },

  watch: {
  },

  mounted () {
    if (this.avalicaoMemoria === true) {
      if (this.avalicaoP != null) {
        this.probabilidadeBanco(this.avalicaoP)
      }
      if (this.avalicaoS != null) {
        this.severidadeBanco(this.avalicaoS)
      }
      if (this.avalicaoCR != null) {
        this.matrizRiscoBanco(this.avalicaoCR)
      }
    }
    this.onLoad()
  },
  methods: {
    cancel () {
      this.cancelaRisco = !this.cancelaRisco
      this.$emit('cancelaRisco', this.cancelaRisco)
    },
    addProbabilidade (id, value, valor) {
      var div = document.getElementById(id)
      this.probabilidade = value

      if (this.probabilidadeSelecionada !== null) {
        var divSelecionada = document.getElementById(this.probabilidadeSelecionada)
        divSelecionada.classList.remove('clicked')
      }
      this.probabilidadeSelecionada = id
      this.probabilidadeValor = valor
      this.probabilidadeDescricaoAvaliacao(this.probabilidade)

      if (this.severidadeValor != null) {
        this.avalicaoMatriz()
      }

      div.classList.add('clicked')
    },
    addSeveridade (id, value, valor) {
      var div = document.getElementById(id)
      this.severidade = value

      if (this.severidadeSelecionada !== null) {
        var divSelecionada = document.getElementById(this.severidadeSelecionada)
        divSelecionada.classList.remove('clicked')
      }
      this.severidadeSelecionada = id
      this.severidadeValor = valor
      this.severidadeDescricaoAvaliacao(this.severidade)

      if (this.probabilidadeValor != null) {
        this.avalicaoMatriz()
      }
      div.classList.add('clicked')
    },
    avalicaoMatriz () {
      this.avalicaoMatrizRisco = this.probabilidadeValor * this.severidadeValor

      if (this.avalicaoMatrizRisco <= 4) {
        this.addMatrizRisco(this.matrizRiscoEnum.T, 0)
      } else if (this.avalicaoMatrizRisco > 4 && this.avalicaoMatrizRisco <= 12) {
        this.addMatrizRisco(this.matrizRiscoEnum.M, 1)
      } else if (this.avalicaoMatrizRisco > 14 && this.avalicaoMatrizRisco <= 20) {
        this.addMatrizRisco(this.matrizRiscoEnum.NT, 2)
      } else {
        toast.error('Erro ao calcular a Matriz de Risco')
      }
    },
    addMatrizRisco (id, value) {
      var div = document.getElementById(id)
      this.matrizRisco = value

      if (this.matrizRiscoSelecionada !== null) {
        var divSelecionada = document.getElementById(this.matrizRiscoSelecionada)
        divSelecionada.classList.remove('clicked')
      }
      this.matrizRiscoSelecionada = id
      this.matrizRiscoDescricaoAvaliacao(this.matrizRisco)
      div.classList.add('clicked')
    },
    onLoad () {
      if (this.avalicaotemplateId === null || this.avalicaotemplateId === undefined) {
        this.probabilidadeSeveridadeMatriz = []
        this.severidade = null
        this.severidadeSelecionada = null
      } else if (this.avalicaoMemoria === false) {
        loading.push()
        aprTemplate.GetProbabilidadeSeveridadeMatrizByAPRTemplate(this.avalicaotemplateId, this.avalicaoRevisao, this.avalicaoRiscoId, this.avalicaoCausaId)
          .then((Response) => {
            loading.pop()
            this.probabilidadeSeveridadeMatriz = Response.data.data
            this.severidade = Response.data.data[0].severidade
            this.probabilidade = Response.data.data[0].probabilidade
            this.matrizRisco = Response.data.data[0].classificacao
            this.severidadeBanco(this.severidade)
            this.probabilidadeBanco(this.probabilidade)
            this.matrizRiscoBanco(this.matrizRisco)
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    },
    severidadeBanco (value) {
      if (value === 0) {
        this.severidadeDescricao = 'I'
        this.addSeveridade(this.severidadeEnum.I, value, value + 1)
      } else if (value === 1) {
        this.severidadeDescricao = 'II'
        this.addSeveridade(this.severidadeEnum.II, value, value + 1)
      } else if (value === 2) {
        this.severidadeDescricao = 'III'
        this.addSeveridade(this.severidadeEnum.III, value, value + 1)
      } else if (value === 3) {
        this.severidadeDescricao = 'IV'
        this.addSeveridade(this.severidadeEnum.IV, value, value + 1)
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a severidade')
      }
    },
    probabilidadeBanco (value) {
      if (value === 0) {
        this.probabilidadeDescricao = 'A'
        this.addProbabilidade(this.probabilidadeEnum.A, value, value + 1)
      } else if (value === 1) {
        this.probabilidadeDescricao = 'B'
        this.addProbabilidade(this.probabilidadeEnum.B, value, value + 1)
      } else if (value === 2) {
        this.probabilidadeDescricao = 'C'
        this.addProbabilidade(this.probabilidadeEnum.C, value, value + 1)
      } else if (value === 3) {
        this.probabilidadeDescricao = 'D'
        this.addProbabilidade(this.probabilidadeEnum.D, value, value + 1)
      } else if (value === 4) {
        this.probabilidadeDescricao = 'E'
        this.addProbabilidade(this.probabilidadeEnum.E, value, value + 1)
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a probabilidade')
      }
    },
    matrizRiscoBanco (value) {
      if (value === 0) {
        this.classificacaoDescricao = 'T'
        this.addMatrizRisco(this.matrizRiscoEnum.T, value, value + 1)
      } else if (value === 1) {
        this.classificacaoDescricao = 'M'
        this.addMatrizRisco(this.matrizRiscoEnum.M, value, value + 1)
      } else if (value === 2) {
        this.classificacaoDescricao = 'NT'
        this.addMatrizRisco(this.matrizRiscoEnum.NT, value, value + 1)
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a Matriz de Risco')
      }
    },
    severidadeDescricaoAvaliacao (value) {
      if (value === 0) {
        this.severidadeDescricao = 'I'
      } else if (value === 1) {
        this.severidadeDescricao = 'II'
      } else if (value === 2) {
        this.severidadeDescricao = 'III'
      } else if (value === 3) {
        this.severidadeDescricao = 'IV'
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a severidade')
      }
    },
    probabilidadeDescricaoAvaliacao (value) {
      if (value === 0) {
        this.probabilidadeDescricao = 'A'
      } else if (value === 1) {
        this.probabilidadeDescricao = 'B'
      } else if (value === 2) {
        this.probabilidadeDescricao = 'C'
      } else if (value === 3) {
        this.probabilidadeDescricao = 'D'
      } else if (value === 4) {
        this.probabilidadeDescricao = 'E'
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a probabilidade')
      }
    },
    matrizRiscoDescricaoAvaliacao (value) {
      if (value === 0) {
        this.classificacaoDescricao = 'T'
      } else if (value === 1) {
        this.classificacaoDescricao = 'M'
      } else if (value === 2) {
        this.classificacaoDescricao = 'NT'
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a Matriz de Risco')
      }
    },
    adicionarAvaliacaoMatriz () {
      this.classificacaoColorVerificacao(this.matrizRisco)
      let itens = {severidade: this.severidade, severidadeDescricao: this.severidadeDescricao, probabilidade: this.probabilidade, probabilidadeDescricao: this.probabilidadeDescricao, classificacao: this.matrizRisco, colorClassificacao: this.colorClassificacao, colorFonteClassificacao: this.colorFonteClassificacao, classificacaoDescricao: this.classificacaoDescricao}
      let avaliacaoMatrizRisco = {edicao: this.edicaoAvaliacao, descricaoStatus: 'AG. ENVIO ALTERAÇÃO DE AVALIAÇÃO', colorStatusAPR: '#dfdfdf', aprTemplate: this.avalicaotemplateId, causaFonteMedidaConseguencia: this.causaMedidaFonteId, aprTemplateAgAprovacao: this.avalicaoAgAprovacaotemplateId, riscoId: this.avalicaoRiscoId, etapaServico: this.etapaServicoId, causaId: this.avalicaoCausaId, itens: itens}

      if (this.severidade != null && this.probabilidade != null && this.matrizRisco != null) {
        this.$emit('matrizRisco', avaliacaoMatrizRisco)
        this.$emit('avaliacao', avaliacaoMatrizRisco)
      } else {
        toast.warning('Certifique-se de que a probabilidade e a severidade foram avaliadas!')
      }
    },
    classificacaoColorVerificacao (value) {
      if (value === 0) {
        this.colorClassificacao = '#CBE9CF'
        this.colorFonteClassificacao = '#1C6228'
      } else if (value === 1) {
        this.colorClassificacao = '#FFD8BB'
        this.colorFonteClassificacao = '#BC4807'
      } else if (value === 2) {
        this.colorClassificacao = '#FFCDCD'
        this.colorFonteClassificacao = '#881616'
      } else {
        toast.warning('Ops! Tivemos um problema para trazer a cor da Matriz de Risco')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/assessmentApr/assessmentApr.js